module.exports = __webpack_public_path__ + "static/favicon-8a744930a64bd6d9f431c950b21c8951.gif";